function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

function SvgLogoXincache(props) {
  const light = props.light || '#999';
  const dark = props.dark || '#000';
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    "uc-svg": "uc-social"
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    d: "M15.671 14.706l2.766 4.423h-6.212l-1.409-2.162-1.468 2.371H3.01l1.81-2.514c2.126-.026 4.931-.438 7.936-1.235 1.02-.27 1.995-.568 2.914-.883zM9.39 4.662l1.464 2.341 1.413-2.341h6.17l-4.502 7.269.236.377c3.27-1.106 5.524-2.517 5.284-3.422-.095-.36-.579-.592-1.332-.702 2.769-.176 4.684.194 4.928 1.117.419 1.577-4.19 4.168-10.294 5.787l-.674.173C6.269 16.707 1.35 16.682.949 15.164c-.245-.923 1.234-2.194 3.726-3.413-.599.469-.904.91-.809 1.27.158.596 1.37.846 3.147.759l.908-1.26-5.119-7.858H9.39z"
  }));
}

SvgLogoXincache.clsName = 'icon-uc-social__logo-xincache';
SvgLogoXincache.remarkName = 'unknown';
export default SvgLogoXincache;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ucloud-icons/dist/uc-social/svgr/LogoXincache.js
// module id = 2267
// module chunks = 17 18